module.exports = __webpack_public_path__ + "static/media/coverPhoto2.e81fcd47.jpg";